import { store } from '@/main';
import { registrationModule } from './store';

export const RegisterPlugin = {
  install: () => {
    // app.config.globalProperties.$exposed = () => ...

    store.registerModule('registration', registrationModule);
  },
};
